import { createAction, props } from '@ngrx/store';
import { AppExceptionModel } from '../../models/app-exception.model';
import { Article } from '../../models/article.model';

export const loadArticle = createAction(
  '[Article] Load to store',
  props<{ articles: Article[] }>(),
);

export const getArticles = createAction(
  '[Article] Get articles',
  props<{ uid: string }>(),
);

export const getArticle = createAction(
  '[Article] Get article',
  props<{ id: string }>(),
);

export const getArticlesFailure = createAction(
  '[Article] Get Articles Failed',
  props<{ error: AppExceptionModel }>(),
);

// Create Article Actions
export const create = createAction(
  '[Article] Create article',
  props<{ article: Partial<Article> }>(),
);
export const createFailure = createAction(
  '[Article] Create article failure',
  props<{ error: any }>(),
);
export const createSuccess = createAction(
  '[Article] Create article success',
  props<{ article: Article }>(),
);

// Update Article Actions
export const update = createAction(
  '[Article] Update',
  props<{ article: Partial<Article> }>(),
);
export const updateFailure = createAction(
  '[Article] Update failure',
  props<{ error: any }>(),
);
export const updateSuccess = createAction(
  '[Article] Update success',
  props<{ article: Article }>(),
);

// Delete Article Actions
export const deleteAction = createAction(
  '[Article] Delete',
  props<{ id: string }>(),
);
export const deleteFailure = createAction(
  '[Article] Delete failure',
  props<{ error: any }>(),
);
export const deleteSuccess = createAction(
  '[Article] Delete success',
  props<{ id: string }>(),
);

export const clearFromStore = createAction(
  '[Article] Clear from store',
  props<{ id: string }>(),
);

export const select = createAction('[Article] Select', props<{ id: string }>());
export const unselect = createAction(
  '[Article] Unselect',
  props<{ id: string }>(),
);

export const clear = createAction('[Article] Clear Articles');
